import { Button, Dropdown, Menu } from 'antd';

import { LockIcon, STRINGS } from '../../libs/ui/src';

import { DownOutlined } from '@ant-design/icons';
import { IntercomService } from '../../services';

export const ConnectionsLeftActions = ({handleActionClick, client}: any) => {
  const actionsMenu = (
    <Menu onClick={handleActionClick}>
      <Menu.Item key="tag">Tag</Menu.Item>
      <Menu.Item disabled={!client.data_credits} key="enhance">
        Enhance Data
        {!client.data_credits && (
          <LockIcon
            message={STRINGS.message_unlock_feature}
            onClick={() => IntercomService.trackIntercomEvent('enhanced_feature_request', true, !client.data_credits)}
          />
        )}
      </Menu.Item>
    </Menu>
  );
  return (
    <div className="connections-page__left-buttons">
      <Dropdown overlay={actionsMenu} trigger={['click']}>
        <Button type="primary" style={{marginRight: '15px'}}>
          Actions <DownOutlined />
        </Button>
      </Dropdown>
    </div>
  );
};
